import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import pozar from "../../../images/patients/pozhar3.jpg";

export default function FireSafety() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Пожарная безопасность
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        При пожаре звонить 01 или 101 с мобильного телефона 112
      </h3>

      <img
        alt="Детям о пожаре"
        className="clinicalbase__image"
        src={pozar}
      ></img>
    </section>
  );
}
